import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import uniqolor from 'uniqolor';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';
import { withBarSelection } from '../../dashboard-helpers';

interface DataType {
  dates?: string;
  values?: {
    name: LangType;
    data: number[];
  }[];
}
export const useOrdersByCategory = (): ChartProps => {
  const { getLocale, currentLang } = useLang();

  const { list } = useDashboardStore();
  const data = list?.orders_by_category as DataType;

  const chartData: ReactApexChartProps = useMemo(() => {
    const categories = data?.dates;
    const pairs = data?.values?.map((item) => ({ ...item, name: getLocale(item.name) })) || [];

    return {
      options: {
        responsive: [
          {
            breakpoint: 1080,
            options: {
              chart: {
                width: '100%',
              },
              legend: {
                position: 'top',
                horizontalAlign: 'left',
              },
            },
          },
          {
            breakpoint: 768,
            options: {
              chart: {
                width: '800px',
              },
            },
          },
        ],
        chart: {
          type: 'bar',
          stacked: true,
          zoom: { enabled: false },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 6.426,
            borderRadiusApplication: 'end',
            hideZeroBarsWhenGrouped: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: true,
          hideEmptySeries: false,
          inverseOrder: true,
        },
        legend: {
          inverseOrder: true,
          position: 'right',
          markers: {
            shape: 'circle',
          },
        },
        xaxis: {
          categories,
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return String(val);
            },
          },
        },
        colors: pairs.map((pair) => uniqolor(pair.name, { format: 'hsl' }).color),
      },
      series: pairs,
    };
  }, [data, getLocale, currentLang]);

  return {
    series: chartData.series,
    options: withBarSelection(chartData).options,
    label: 'Статистика заказов по категориям',
    subLabel:
      'Дашборд отображает диаграмму, показывающую количество заказов по каждой категории меню за выбранный период. Чем больше сегмент, тем выше популярность категории',
    type: 'bar',
    wrapped: true,
  };
};
